<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-bodymatter element-container-single element-type-chapter element-with-heading" id="vol-1-chapter-15">
<div class="heading heading-with-title heading-without-image" id="vol-1-chapter-15-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-title-is-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">15</h1>
</div>
</div>
</div>
</div>
<div class="text" id="vol-1-chapter-15-text">
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center"><i>Fear is just a state of mind. Meet it, feel it, bask in it. Make it your friend. Once you’ve done that, I kid you not, the world is yours to conquer.</i></p>
</div>
</div>
<hr class="implicit-break"/>
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center"><i>Address to new recruits of the 22nd Special Air Service Regiment.</i></p>
</div>
</div>
<hr class="implicit-break"/>
<p class="first first-in-chapter first-full-width"><span class="drop-cap">T</span>heir house was one of four cottages built on roughly two acres of land. The original buildings were old and solid, constructed about a hundred and twenty years earlier for tenant farmers. They had been enlarged and modernised over time, each standing on its own half acre, each separated from the other with mature trees and bushes and leafy borders. It was love at first sight, at least for Jennifer, with its white stucco walls laced with lush crimson ivy, its rust-red slated roof, its secluded garden. Quaint and private. Country but not quite country. Amenities only a mile away. They were about fifty yards from the main road, accessed by a single private lane, the lane running by the houses, two on each side, coming to a turning point at its dead end – a hammer-head.</p>
<p class="subsq">To get to the house from his office would normally take Black, driving his Mini Cooper at sedate speed, about thirty-five minutes. When he got the call from Jennifer, he was there in twenty.</p>
<p class="subsq">He saw it immediately when he pulled into the lane. At the top, fifty yards from their house and parked in the hammer-head, a shining, gunmetal grey 7 series BMW, with brand new licence plates.</p>
<p class="subsq">He pulled up outside his own house. Jennifer was standing at the front door, Merryn beside her, holding hands, Merryn dressed for nursery, Jennifer for work.</p>
<p class="subsq">Black got out, made his way up to them.</p>
<p class="subsq">“It might be nothing,” she said. She was pale, exhaustion etched on her face, her hazel-brown eyes heavy with lack of sleep. “I saw it drive up about a half hour ago. It’s just sitting there. There’s two men in it. No one’s got out. No one’s doing anything. I didn’t know whether I should call the police. But then if I did, they’d probably think I was crazy. I probably am. I’m so sorry, Adam.” Tears welled up; her mouth quivered, as she stifled a sob. “The whole thing is crazy.”</p>
<p class="subsq">“You’re not crazy,” soothed Black. He held her and spoke gently in her ear. “It’s a mess right now. But it’ll clear up. We need to give it time. They’re probably more journalists, trying to get a scoop. Maybe this is the reaction they wanted. To try to get me to speak to them.  Merryn’s ready for nursery, so go to work, and act like everything’s normal. Soon it will be normal. I promise.”</p>
<p class="subsq">He cupped her chin in his hands, looked into her eyes.</p>
<p class="subsq">“I promise.”</p>
<p class="subsq">“You sure?”</p>
<p class="subsq">Black nodded.</p>
<p class="subsq">“What are you going to do?”</p>
<p class="subsq">“Have a chat. As a concerned neighbour.”</p>
<p class="subsq">“Then we’ll stay right here.”</p>
<p class="subsq">Black gave a small half-smile. “Fair enough. I won’t be long.”</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// vol001chapter015.vue?fa46ecda